import CitySEOHead from "@/components/feature/CitySEOHead";
import FortMyersHeroSection from "./components/HeroSection";
import FortMyersStickyNav from "./components/StickyNav";
import FortMyersProcessingTimeSection from "./components/ProcessingTimeSection";
import FortMyersServicesSection from "./components/ServicesSection";
import FortMyersLocalAreaSection from "./components/LocalAreaSection";
import FortMyersTravelTimingSection from "./components/TravelTimingSection";
import FortMyersDestinationsSection from "./components/DestinationsSection";
import FortMyersTestimonialsSection from "./components/TestimonialsSection";
import FortMyersAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import FortMyersComparisonSection from "./components/ComparisonSection";
import FortMyersMistakesSection from "./components/MistakesSection";
import FortMyersHowItWorksSection from "./components/HowItWorksSection";
import FortMyersFAQSection, { faqs } from "./components/FAQSection";
import FortMyersHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FortMyersFinalCTA from "./components/FinalCTA";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function FortMyersPage() {
  return (
    <>
      <CitySEOHead
        city="Fort Myers"
        state="Florida"
        stateAbbr="FL"
        route="/cities/fort-myers"
        title="Emergency Passport Fort Myers, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Fort Myers, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Lee County travelers, families, and spring training visitors."
        geoPlacename="Fort Myers, Florida"
        geoPosition="26.6406;-81.8723"
        faqs={faqs}
        servicesSchema={servicesSchema}
      />
      <div className="font-sans">
        <FortMyersHeroSection />
        <FortMyersStickyNav />
        <FortMyersProcessingTimeSection />
        <FortMyersServicesSection />
        <FortMyersLocalAreaSection />
        <FortMyersTravelTimingSection />
        <FortMyersDestinationsSection />
        <FortMyersTestimonialsSection />
        <FortMyersAcceptanceFacilitiesSection />
        <FortMyersComparisonSection />
        <FortMyersMistakesSection />
        <FortMyersHowItWorksSection />
        <FortMyersFAQSection />
        <FortMyersHelpfulResourcesSection />
        <FortMyersFinalCTA />
      </div>
    </>
  );
}